<script>
export default {
  props: {
    tableData: {
      type: Array,
      default () {
        return []
      }
    },
    isShowBusinessCard: {
      type: Boolean,
      default: false
    },
    cardImageData: {
      type: String,
      default: ''
    }
  },
  computed: {
    tableShowData () {
      return this.tableData[0]
    }
  }
}
</script>
<template>
  <div id="my-node" @click="$emit('view')">
    <div class="table-title">
      <h2>专属定制的保障方案</h2>
    </div>
    <table v-if="tableData.length" class="table-layout">
      <thead>
        <tr>
          <th>被保人</th>
          <th>产品名称</th>
          <th>保额</th>
          <th>保险期</th>
          <th>交费期</th>
          <th>首年保费</th>
          <th>保障责任</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(product, pIndex) in tableShowData.tableList"
          :key="`${pIndex}`"
        >
          <template v-if="!pIndex">
            <td class="table-bg" :rowspan="tableShowData.tableList.length + 1">
              {{ tableShowData.insuredInfo.sexDesc }}
              {{ tableShowData.insuredInfo.age }}岁
            </td>
          </template>
          <td>{{ product.titleName }}</td>
          <td>{{ product.baoeDp }}</td>
          <td>{{ product.iDurationDesc }}</td>
          <td>{{ product.pPeriodDesc }}</td>
          <td>{{ product.totalBaof }}</td>
          <td>
            <div
              v-for="(item, idx) in product.liability"
              :key="idx"
              class="description1"
              v-html="item.parsedDesc1"
            />
          </td>
        </tr>
        <tr>
          <td colspan="4">
            总计
          </td>
          <td>{{ tableShowData.totalBaof }}</td>
          <td />
        </tr>
      </tbody>
    </table>
    <div v-if="isShowBusinessCard" class="card_image_wrap">
      <img :src="cardImageData" alt="名片">
    </div>
  </div>
</template>
<style lang="postcss" scoped>
@import './table.css';
.table-layout {
  thead {
    th {
      &:first-child {
        width: 10%;
      }
      &:nth-child(2) {
        width: 17.5%;
      }
      &:nth-child(3),
      &:nth-child(4),
      &:nth-child(5) {
        width: 7.5%;
      }
      &:nth-child(6) {
        width: 10%;
      }
    }
  }
  tbody {
    td:nth-last-child(2),
    td:nth-last-child(5) {
      color: #ff5000;
    }
    tr:last-child {
      td {
        background-color: #f8f8f8;
        &:nth-last-child(2) {
          color: #ff5000;
        }
      }
    }
  }
}
.card_image_wrap {
  width: 100%;
  background: white;
  & img {
    margin: 0 auto;
  }
}
</style>